import * as React from 'react';
import { FC, PropsWithChildren, ReactElement } from 'react';
import styles from './floating-actions.module.sass';
import { Button, ButtonGroup, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';

export type FloatingActionPosition = 'right' | 'left' | 'center';

export interface FloatingActionProps {
    actions: ActionData[];
    sideAction?: ActionData;
    position?: FloatingActionPosition;
}

export interface ActionData {
    icon: string;
    callback?: () => void;
    href?: string;
    externalLink?: boolean;
    tooltipText?: string;
    tooltipArrowProps?: any;
    colorClass?: string;
    subData?: ReactElement[];
}

export const FloatingActions: FC<PropsWithChildren<FloatingActionProps>> = (props) => {

    const applyOverlayIfRequired = (action: ActionData, index: number, children: any) => {
        if (action.tooltipText)
            return <OverlayTrigger
                trigger={['hover', 'focus']}
                placement="top"
                overlay={action.tooltipArrowProps ?
                    <Tooltip data-container="body"
                             arrowProps={action.tooltipArrowProps}>{action.tooltipText}</Tooltip> :
                    <Tooltip data-container="body">{action.tooltipText}</Tooltip>}
                key={`${index * 13}-${action.tooltipText}`}
                rootClose={true}>
                {children}
            </OverlayTrigger>;
        else
            return children;

    };

    const buildButtonOrLink = (action: ActionData, index: number) => {

        if (action.subData && action.subData.length > 0)
            return <Dropdown key={`${index * 8}-${action.tooltipText}`} as={ButtonGroup} drop={'up'}
                             variant="secondary">
                {applyOverlayIfRequired(action, index, <Dropdown.Toggle key={`${index * 9}-${action.tooltipText}`}><i
                    className={action.icon} /></Dropdown.Toggle>)}
                <Dropdown.Menu>
                    {action.subData}
                </Dropdown.Menu>
            </Dropdown>;

        if (action.href)
            return applyOverlayIfRequired(action, index, <a href={action.href}
                                                            key={`${index * 11}-${action.tooltipText}`}
                                                            className={`btn btn-secondary ${action.colorClass}`}
                                                            target={action.externalLink ? '_blank' : '_self'}
                                                            rel="noopener noreferrer">
                <i className={`${action.icon} icon-with-text`} />
            </a>);
        else
            return applyOverlayIfRequired(action, index, <Button variant="secondary" className={action.colorClass}
                                                                 key={`${index * 12}-${action.tooltipText}`}
                                                                 onClick={action.callback}>
                <i className={action.icon} />
            </Button>);
    };

    const actions = (actions: ActionData[]) => actions.map((action, index) => buildButtonOrLink(action, index));

    return (
        <div className={`${styles.floatingActionsBarWrapper} ${props.position ? props.position : 'center'}`}>
            <div className={styles.floatingActionsBar}>
                {actions(props.actions)}
            </div>
            {props.sideAction &&
                <div className={`${styles.floatingActionsBar} ${styles.sideAction}`}>
                    {actions([props.sideAction])}
                </div>
            }
        </div>
    );
};

